/* lua.js generated code undefined */

UserTagConst = table(
    [1, "TagInterval", 1000],
    [1, "ActiveLevel_NoData", 1000],
    [1, "ActiveLevel_NewUser", 1001],
    [1, "ActiveLevel_Active", 1002],
    [1, "ActiveLevel_Normal", 1003],
    [1, "ActiveLevel_Losing", 1004],
    [1, "ActiveLevel_Return", 1005],
    [1, "SingleLevelHardness_NoData", 2000],
    [1, "SingleLevelHardness_Easy", 2001],
    [1, "SingleLevelHardness_Normal", 2002],
    [1, "SingleLevelHardness_Hard", 2003],
    [1, "SingleLevelHardness_Extreme", 2004],
    [1, "MultiLevelHardness_NoData", 3000],
    [1, "MultiLevelHardness_Easy", 3001],
    [1, "MultiLevelHardness_Normal", 3002],
    [1, "MultiLevelHardness_Hard", 3003],
    [1, "MultiLevelHardness_Extreme", 3004],
    [1, "SevenDayPayment_Zero", 4000],
    [1, "SevenDayPayment_Low", 4001],
    [1, "SevenDayPayment_Medium", 4002],
    [1, "SevenDayPayment_High", 4003],
    [1, "ThirtyDayPayment_Zero", 5000],
    [1, "ThirtyDayPayment_Low", 5001],
    [1, "ThirtyDayPayment_Medium", 5002],
    [1, "ThirtyDayPayment_High", 5003],
    [1, "AccumulatePayment_Zero", 6000],
    [1, "AccumulatePayment_Low", 6001],
    [1, "AccumulatePayment_Medium", 6002],
    [1, "AccumulatePayment_High", 6003]
)
